import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { _HttpClient } from 'src/app/core/net/http.client';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SettingsService } from 'src/app/core/services/settings.service';
import { ApiService } from 'src/app/core/net/apiRoute';
import { NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { Observable, Observer, of, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { generateTaskId } from '../utils';
import { FormArray, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SrcPipe } from '../src.pipe';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';

import Compressor from 'compressorjs';
import { async } from 'rxjs/internal/scheduler/async';
@Component({
  selector: 'app-upload-file',
  templateUrl: './app-upload-file.component.html',
  styleUrls: ['./app-upload-file.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppUploadFileComponent),
      multi: true,
    }
  ]
})
export class AppUploadFileComponent {
  @Output() onRemoveItem: EventEmitter<any> = new EventEmitter(); // 输出键集合
  @Output() srcUrl: EventEmitter<any> = new EventEmitter(); // 输出键集合
  @Input() defaultSrc: any;   // 默认值
  @Input() maxFileSize: number = 10240;//最大文件大小 单位M
  @Input() accept = ".png,.gif,.jpg,.bmp,.jpeg,.mp4,.pdf,.xlsx,.docx";//接受文件类型
  //0图片上传 1上传头像 2文件列表
  @Input() type: number = 0;
  @Input() foldername: string = "";
  @Input() showList: boolean = false;
  private _fileList: NzUploadFile[] = [];
  @Input() get fileList() {
    return this._fileList;
  }

  set fileList(value) {
    if (value == null) {
      this._fileList = [];
    }
    else {
      this._fileList = value;
    }
  }

  uploadUrl = '';
  isOssUpload = false;


  constructor(
    public settings: SettingsService,
    public http: _HttpClient,
    private msg: NzMessageService,
    private srcPip: SrcPipe
  ) {
    this.isOssUpload = environment.aliyunOSS.use;
    this.uploadUrl = ApiService.UploadFile; // 文件上传接口地址
    if (this.type == 2) {
      this.showList = true;
    }

    if (!this.fileList) {
      this.fileList = [];
    }

  }


  ngOnInit(): void {

  }

  propagateChange = (_: any) => { };
  writeValue(value: any): void {
    this.defaultSrc = value;
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }

  // 上传前
  beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]) => {
    return new Observable((observer: Observer<boolean>) => {
      const isLt2M = (file.size! / 1024 / 1024) < this.maxFileSize;

      if (!isLt2M) {
        this.msg.error('文件必须小于 ' + this.maxFileSize + 'MB');
        observer.complete();
        return;
      }
      observer.next(isLt2M);
      observer.complete();

    });
  }

  transformFile = (file: NzUploadFile) => {
    if (environment.aliyunOSS.use) {
      const suffix = file.name.slice(file.name.lastIndexOf('.'));
      const filename = generateTaskId() + suffix;
      file.url = "Resource/" + filename;
    }

  }
 
  getExtraData = (file: NzUploadFile) => {

    if (environment.aliyunOSS.use) {
      const { accessKeyId } = environment.aliyunOSS;
      return {
        key: file.url,
        success_action_status: '201'
      };
    }
  };

  nzCustomRequest = (item: NzUploadXHRArgs) => {
    if (this.isOssUpload) {
      return this.aiyunOssUpload(item);
    } else {
      return this.defaultUpload(item);
    }

  }

  aiyunOssUpload(item: NzUploadXHRArgs) {
    return new Observable<any>((observer) => {
      if (this.checkImage(item.file as any)) {
        new Compressor(item.file as any, {
          quality: 0.6,
          convertSize: 1000000,
          success: (result) => {
            observer.next(result);
          },
          error(err) {
            observer.error(err.message);
          },
        })
      } else {
        observer.next(item.file as any);
      }
    }).pipe(map((result) => {
      const formData = new FormData();
      formData.append('key', item.file.url);
      formData.append('success_action_status', '201')
      formData.append('file', result);
      // Always returns a `Subscription` object. nz-upload would automatically unsubscribe it at correct time.
      return this.http.post(this.uploadUrl, formData, false, null, {
        responseType: 'text'
      }).subscribe(
        (data: any) => {
          var pattern = /<Location>(.*)<\/Location>/i
          var value = pattern.exec(data);
          var lastIndex = value[1].indexOf('/Resource');
          var sortUrl = value[1].substring(lastIndex);
          item.onSuccess({
            Status: 1,
            Result: sortUrl
          }, item.file, item);
        },
        err => {
          item.onError!(err, item.file!);

        }
      );
    }))
      .subscribe();
  }
  public checkImage(file: File): boolean {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/bmp';
    if (!isJpgOrPng) {
      return false;
    }
    return true;
  }

  defaultUpload(item: NzUploadXHRArgs) {
    return new Observable<any>((observer) => {
      if (this.checkImage(item.file as any)) {
        new Compressor(item.file as any, {
          quality: 0.6,
          convertSize: 1000000,
          success: (result) => {
            observer.next(result);
          },
          error(err) {
            observer.error(err.message);
          },
        })
      } else {
        observer.next(item.file as any);
      }
    }).pipe(map((result) => {
      const suffix = item.file.name.slice(item.file.name.lastIndexOf('.'));
      const filename = generateTaskId() + suffix;
      const formData = new FormData();
      formData.append('foldername', this.foldername);
      formData.append('file', result, filename);
      return this.http.post(this.uploadUrl, formData, false, null, {
        reportProgress: true,
        observe: 'events'
      }).pipe(filter((f) => {
        switch (f.type) {
          case HttpEventType.UploadProgress: {
            var percent = Math.round(100 * f.loaded / f.total);
            item.onProgress!({ percent: percent }, item.file!);
            break;
          }
          case HttpEventType.Response: {
            return true;
          }
        }
        return false;
      }),
        map((n: HttpResponse<any>) => n.body)).subscribe(
          (data: any) => {
            item.onSuccess({
              Status: data.Status,
              Result: data.Result
            }, item.file, item);
          },
          err => {
            item.onError!(err, item.file!);

          }
        );
    })).subscribe();
  }


  // 上传后
  handleChange(info: NzUploadChangeParam) {

    if (info.file.status !== 'uploading') {

    }
    if (info.file.status === 'done') {
      const response = info.file.response;
      if (response.Status === 1) {
        if (this.isOssUpload) {
          this.srcUrl.emit(response.Result);
          if (!this.showList) {
            this.propagateChange(response.Result);
          } else {
            this.fileList.push({
              uid: info.file.uid,
              name: info.file.name,
              status: 'done',
              url: response.Result,
              thumbUrl: response.Result
            });
            this.propagateChange(this.fileList);

          }

        } else {
          const res = info.file.response.Result[0];
          // 通知父组件

          if (!this.showList) {
            this.srcUrl.emit(res.shortPath);
            this.defaultSrc=res.shortPath;
            this.propagateChange(res.shortPath);
          } else {
            this.srcUrl.emit({
              info: info,
              url: res.shortPath
            });
            this.fileList.push({
              uid: info.file.uid,
              name: info.file.name,
              status: 'done',
              url: res.shortPath,
              thumbUrl: res.shortPath
            });
            this.propagateChange(this.fileList);
          }

        }

        this.msg.success(`上传成功`);
      }
    } else if (info.file.status === 'error') {
      this.msg.error(`上传失败`);
    }
  }

  fileselectClick(e) {
    if (e) {
      e.preventDefault();
    }
  }

  onRemove = (file: NzUploadFile) => {
    this.onRemoveItem.emit(file);
    var index = this.fileList.findIndex(n => n.url == file.url);
    this.fileList.splice(index, 1);
    this.propagateChange(this.fileList);
    return true;
  }
  DownloadFile = async (file: NzUploadFile) => {
    //console.log(this.srcUrl.emit(file.response.Result[0].shortPath));
    window.open(this.srcPip.transform(file.url));
  }
  PreviewFile = async (file: NzUploadFile) => {

    window.open(this.srcPip.transform(file.url));
  }


  deleteItem(e){
    var index =this._fileList.indexOf(e);
    this._fileList.splice(index,1)
  }

  getFileName(url){
    if(url!=undefined&&url!=""&&url!=null){
      return url.substring(url.lastIndexOf('/')+1);
    }
  }
  openLink(e){
    e.stopPropagation();
  }
}
